import { FoldVertical, UnfoldVertical } from "lucide-solid";
import { For, Show } from "solid-js";
import { useService } from "solid-services";
import { css } from "styled-system/css";
import { Box, Flex } from "styled-system/jsx";
import type { SectionFilter } from "../useCourseOverview";
import { useCourseOverview } from "../useCourseOverview";

const TABS: { value: SectionFilter; label: string }[] = [
  { value: 'all', label: 'All' },
  { value: 'active', label: 'In progress' },
  { value: 'todo', label: 'Not started' },
]

export default function () {
  const { filter, setFilter, allVisibleOpen, toggleExpandAll } = useService(useCourseOverview)()

  return (
    <Flex align="center" gap="11px" mb="13px" px="2px" flexWrap="wrap">
      <Box fontSize="13px" fontWeight="700" color="editorialInk">
        Course content
      </Box>

      <Flex bg="editorialHover" border="1px solid var(--colors-editorial-hair)" borderRadius="9px" p="2px">
        <For each={TABS}>
          {(tab) => (
            <button
              type="button"
              onClick={() => setFilter(tab.value)}
              class={css({
                border: 'none',
                fontFamily: 'inherit',
                fontSize: '12px',
                fontWeight: '600',
                padding: '5px 11px',
                borderRadius: '7px',
                cursor: 'pointer',
                color: filter() === tab.value ? 'editorialInk' : 'editorialInk2',
                bg: filter() === tab.value ? 'editorialPanel' : 'transparent',
                boxShadow: filter() === tab.value ? '0 1px 2px rgba(20,22,27,.1)' : 'none',
              })}
            >
              {tab.label}
            </button>
          )}
        </For>
      </Flex>

      <button
        type="button"
        onClick={toggleExpandAll}
        class={css({
          marginLeft: 'auto',
          display: 'inline-flex',
          alignItems: 'center',
          gap: '6px',
          border: 'none',
          bg: 'transparent',
          fontFamily: 'inherit',
          fontSize: '12px',
          fontWeight: '600',
          color: 'editorialInk2',
          cursor: 'pointer',
          padding: '6px 4px',
          '&:hover': { color: 'editorialInk' },
        })}
      >
        <Show when={allVisibleOpen()} fallback={<UnfoldVertical size={14} />}>
          <FoldVertical size={14} />
        </Show>
        {allVisibleOpen() ? 'Collapse all' : 'Expand all'}
      </button>
    </Flex>
  )
}
